import axios from 'axios';
import '@popperjs/core';
import * as bootstrap from 'bootstrap';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = axios.create({
    baseURL: `${window.location.protocol}//${window.location.hostname}`,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
});

// Bootstrap components
window.bootstrap = bootstrap;

document.addEventListener('DOMContentLoaded', () => {
    // Dropdown
    [].slice
        .call(document.querySelectorAll('.dropdown-toggle'))
        .map((dropdownToggleEl) => new bootstrap.Dropdown(dropdownToggleEl));

    // Popovers
    [].slice
        .call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        .map((popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl));

    // Tooltips
    [].slice
        .call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        .map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));

    // Toasts
    [].slice.call(document.querySelectorAll('.toast')).map((toastEl) =>
        new bootstrap.Toast(toastEl, {
            delay: 5000,
        }).show()
    );

    // Popover image
    [].slice.call(document.querySelectorAll('[data-toggle="popover-img"]')).map(
        (popoverTriggerEl) =>
            new bootstrap.Popover(popoverTriggerEl, {
                container: 'body',
                trigger: 'hover',
                html: true,
                placement: 'bottom',
                content() {
                    return `<img class="img-fluid" src="${popoverTriggerEl.getAttribute(
                        'data-img'
                    )}"  alt="img"/>`;
                },
            })
    );
});
